import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'

import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'site-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const columns = [
  {
    title: 'Client Id',
    dataIndex: 'clientId',
    sorter: (a, b) => a.clientId.localeCompare(b.clientId)
  },
  {
    title: 'Site Id',
    dataIndex: 'siteId',
    render: (name, row) => (
      <Link to={ROUTES.SITE_EDIT.replace(':siteId', row.siteId).replace(':targetClientId', row.clientId)}>
        {name}
      </Link>
    ),
    sorter: (a, b) => a.siteId.localeCompare(b.siteId)
  },
  {
    title: 'Description',
    dataIndex: 'description',
    sorter: (a, b) => a.description.localeCompare(b.description)
  },
  {
    title: 'Address',
    dataIndex: 'address',
    sorter: (a, b) => a.address.localeCompare(b.address)
  },
  {
    title: 'Time Zone',
    dataIndex: 'timeZone',
    sorter: (a, b) => a.timeZone.localeCompare(b.timeZone)
  }
]

const ListView = ({ sites }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {sites.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {sites.length} sites
      </PageContentUnderTitle>
    )}
    <Table dataSource={sites} columns={columns} pagination={false} rowKey={"clientId"+"siteId"} />
  </div>
)

export default ListView



// WEBPACK FOOTER //
// ./src/pages/summary/summary-list/components/list-view/index.js